import Loadable from 'react-loadable';

export const EndpointsListContainer = Loadable({
  loader: () => import('./EndpointsList'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/EndpointsList/index.ts